










































































































































































































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import AccountHelpers, { Account } from "@/models/account";
import BillingAccountHelpers, { BillingAccount } from "@/models/billingAccount";
import AccountSearchHelpers, { AccountSearch } from "@/models/accountsearch";
import loader from "@/components/loader.vue";
import accountsApi from "@/services/accounts";
import { debounce, cancel } from "typescript-debounce-decorator";
import { Getter, Action, Mutation } from "vuex-class";

import BillingAddress from "./BillingAddress.vue";

import { NSLog } from "@/helpers/log";
import { save } from "@/helpers/storage";
import { Order } from "@/models/order";
const log = NSLog("view/PlaceUserOrder");

@Component({
  components: {
    loader,
    BillingAddress,
  },
})
export default class BillingAccountComponent extends Vue {
  // selected account helpers account
  private get billingAccountID() {
    return this.billingAccount ? this.billingAccount.id : null;
  }
  private get billingAccountDisplayText() {
    return this.billingAccountID
      ? BillingAccountHelpers.DisplayText(this.billingAccount)
      : this.accountSearchStr;
  }
  @Mutation("setLastErr") public setLastErr: any;

  @Prop() public value?: BillingAccount;
  @Prop() public order?: Order;
  private loading = false;

  private tabIdx = 0;

  private billingAccount?: BillingAccount = BillingAccountHelpers.New();

  private foundBillingAccounts: any = [];
  private newValid = false;
  private newBillingAccount?: BillingAccount = BillingAccountHelpers.New();
  private newLoading = false;

  private selectedValid = false;
  private updateModified = false;
  private updateLoading = false;

  // ============================================== \\
  // =========== search billing account =========== \\
  // ============================================== \\
  private accountSearchStr = "";

  @Watch("value") public watchBillingAccount(newAccount: BillingAccount) {
    if (newAccount && newAccount.id > 0) {
      this.billingAccount = this.value;
      this.tabIdx = 0;
      setTimeout(() => (this.tabIdx = 2), 50);
    }
  }
  public created() {
    if (this.value) {
      this.billingAccount = this.value;
      this.tabIdx = 2;
    }
  }
  @Watch("accountSearchStr") public watchAccountSearchStr(v: string) {
    this.searchBillingAccounts(v);
  }

  // ============================================== \\
  // ========= set / updatebilling account ======== \\
  // ============================================== \\
  private async setBillingAccount(acc?: BillingAccount) {
    if (!acc) {
      this.billingAccount = BillingAccountHelpers.New();
      this.updateModified = false;
      this.$emit("input", this.billingAccount);
    } else if (!this.billingAccount || this.billingAccount.id !== acc.id) {
      this.billingAccount = acc;
      this.$emit("input", this.billingAccount);
      this.tabIdx = 2;
    }
  }
  private async searchBillingAccounts(str?: string) {
    if (str === undefined) {
      this.foundBillingAccounts = [];
    }
    if (!str || str.length < 3) {
      return;
    }
    this.loading = true;
    this.searchBillingAccountsDebounce(str);
  }
  private clearSearch() {
    this.setBillingAccount();
    this.searchBillingAccounts();
  }
  // debounced search account
  @debounce(500, { leading: false })
  private async searchBillingAccountsDebounce(str: string) {
    this.setLastErr();
    this.loading = true;
    try {
      this.foundBillingAccounts = await accountsApi.searchBillingAccounts(str);
    } catch (e) {
      this.setLastErr(e);
    }
    this.loading = false;
  }

  private async createBillingAccountAndSelect() {
    this.setLastErr();
    this.newLoading = true;
    if (!this.newBillingAccount) {
      return;
    }
    try {
      const newAccount = await accountsApi.CreateBillingAccount(
        this.newBillingAccount
      );
      this.billingAccount = newAccount;
      this.tabIdx = 2;
      this.newBillingAccount = BillingAccountHelpers.New();
      this.$emit("next", this.billingAccount);
    } catch (e) {
      this.setLastErr(e);
    }
    this.newLoading = false;
  }

  private async updateBillingAccountAndContinue() {
    this.setLastErr();
    this.updateLoading = true;
    if (!this.billingAccount) {
      return;
    }
    try {
      const newAccount = await accountsApi.UpdateBillingAccount(
        this.billingAccount
      );
      this.billingAccount = newAccount;
      this.$emit("next", this.billingAccount);
    } catch (e) {
      this.setLastErr(e);
    }
    this.updateLoading = false;
    this.updateModified = false;
  }

  private async selectBillingAccountAndContinue() {
    this.$emit("next", this.billingAccount);
  }

  private destroyed() {
    cancel(this.searchBillingAccountsDebounce);
  }
}
